<template>
  <IconButton
    variant="close"
    :size="size"
    :as="as"
    :asChild="asChild"
    :class="props.class"
    :disabled="disabled"
    :aria-label="t('components.buttons.close')"
  >
    <Icon name="close" aria-hidden size="xl" />
  </IconButton>
</template>

<script setup>
import { IconButton } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  size: { type: null, required: false },
  as: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  class: { type: null, required: false },
  disabled: { type: Boolean, default: false },
});
</script>
